import React, { cloneElement } from 'react';
import {
  Button,
  Col,
  Row,
  Form,
  Table,
  Label,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormGroup,
} from 'reactstrap';
import axios from 'axios';
import StorageService from '../services/StorageService';
import { MdDone, MdClear, MdCreate, MdSearch } from 'react-icons/md';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { Redirect } from 'react-router';
import CrmCustomerDataForm from '../components/CrmCustomerDataForm';
import { BsPlusSquareFill } from 'react-icons/bs';
import { IconContext } from 'react-icons/lib';

class CrmCustomerDataTable extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      confirmModal: false,
      isGlobal: '',
      dataList: [],
      dataTemplate: [],
      filteredList: [],
      redirect: false,
      selectedId: '',
      selectedData: '',
      searchKey: '',
      col: 0,
    };
  }

  componentDidMount() {
    const user = StorageService.getSession('user_info');
    //if (user.superUser) {
    this.getDataTemplate();
    this.getDataList();
    // } else {
    //   this.setState({
    //     redirect: true,
    //   });
    // }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  toggle = (action, data) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit:
        data != undefined || (data != null && action == 'EDIT') ? true : false,
      selectedData: data,
    });
  };

  toggleConfirmModal = (name, id) => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedData: name,
      selectedId: id,
    });
  };

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      modal: false,
    });

    if (reload) {
      window.location.reload();
    } else {
      this.getDataList();
    }
  };

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  getDataList = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      customer_id: this.props.match.params.id,
    };
    axios
      .post(url + ':3004/v1/customer/detail', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          this.setState({
            dataList: result.data.data,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  getDataTemplate = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };
    axios
      .post(url + ':3004/v1/customer/template', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          this.setState({
            dataTemplate: result.data,
            col: result.data.length,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  delete = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      data_id: this.state.selectedId,
      remove_by: user.email,
    };

    axios
      .post(url + ':3004/v1/customer/data/delete', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          return;
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Data deleted successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });
        this.setState({ confirmModal: false });
        this.getDataList();
      })
      .catch(error => {
        alert(error);
      });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    const dataTemplate = (
      <tr>
        {this.state.dataTemplate.map(item => {
          return <th key={item.name}>{item.title}</th>;
        })}
        <th>Action</th>
      </tr>
    );

    const dataList =
      this.state.dataList.length > 0 &&
      this.state.dataList.map(item => {
        return (
          <tr key={item.data_id}>
            {this.state.dataTemplate.map((template, i) => {
              let value = '';
              Object.keys(item).map((subitem, index) => {
                if (subitem != 'data_id') {
                  if (template.name === subitem) {
                    value = item[subitem];
                    // return <td key={subitem + index}>{item[subitem]}</td>;
                  }
                }
              });
              return <td key={value + i}>{value}</td>;
            })}
            {/* {Object.keys(item)
              .sort()
              .map((subitem, index) => {
                if (subitem != 'data_id') {
                  return <td key={subitem + index}>{item[subitem]}</td>;
                }
              })} */}
            <td>
              <div className="ps-action-button">
                <Button
                  className="theme-button theme-button-secondary"
                  onClick={this.toggle('EDIT', item)}
                >
                  Edit
                </Button>
                <Button
                  className="theme-button theme-button-primary-light"
                  onClick={this.toggleConfirmModal(item.model, item.data_id)}
                >
                  Delete
                </Button>
              </div>
            </td>
          </tr>
        );
      });

    return (
      <>
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />

        <Row>
          <Col>
            <div className="text-right mb-3">
              <div className="ps-btn-group">
                <Button color="link" onClick={this.toggle('ADD', null)}>
                  <IconContext.Provider value={{ color: '#2a2c6b' }}>
                    <BsPlusSquareFill size={25} />
                  </IconContext.Provider>
                </Button>
              </div>
            </div>
          </Col>
        </Row>

        <Table
          responsive
          hover
          className={`ps-table tb-col-${this.state.col} th-no-wrap`}
        >
          <thead>{dataTemplate}</thead>
          <tbody>
            {this.state.dataList.length < 1 ? (
              <tr>
                <td colSpan={this.state.col}>
                  <div className="ps-empty-data">
                    <div className="empty-content">
                      <MdCreate />
                      <h4>No data to show</h4>
                      <span>
                        Click the {this.state.isGlobal ? 'Create' : 'Add'}{' '}
                        button to add new data
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            ) : (
              dataList
            )}
          </tbody>
        </Table>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle()}
          className={this.props.className}
          centered
        >
          <CrmCustomerDataForm
            history={this.props.history}
            onToggleModal={this.toggle}
            closeModal={this.closeModal}
            match={this.props.match}
            data={this.state}
            customerData={this.props.data}
          />
        </Modal>

        <Modal
          isOpen={this.state.confirmModal}
          toggle={this.toggleConfirmModal()}
          className={this.props.className}
          centered
          style={{ fontSize: '0.85rem' }}
        >
          <ModalHeader toggle={this.toggleConfirmModal()}>
            {this.state.isGlobal ? 'Delete' : 'Remove'} Product
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>
                  Are you sure you want to{' '}
                  {this.state.isGlobal ? 'delete' : 'remove'}{' '}
                  {this.state.selectedData} ?
                </p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              className="theme-button theme-button-secondary"
              onClick={this.toggleConfirmModal()}
            >
              No
            </Button>
            <Button
              className="theme-button theme-button-primary"
              onClick={() => this.delete()}
            >
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}
export default CrmCustomerDataTable;
